import React from 'react';
import { Accordion } from 'semantic-ui-react';
import AccordionHeader from '@/components/accordion/AccordionHeader';
import PermissionsTools from '../containers/PermissionsTools';

const PermissionsContainer = ({
  active,
  index,
  count,
  onClick,
  title,
  children,
  category,
  code,
  categories,
}) => (
  <>
    <AccordionHeader active={active} index={index} onClick={onClick} headerId={title}>
      <div className="float-r">
        <PermissionsTools
          count={count}
          category={category}
          code={code}
          permissionCategories={categories}
        />
      </div>
    </AccordionHeader>
    {active && (
      <Accordion.Content active={active}>
        {children}
      </Accordion.Content>
    )}
  </>
);

export default PermissionsContainer;
